var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"id":"temas-select","items":_vm.values,"label":_vm.isParceiro
      ? 'Parceiros'
      : _vm.isSala
      ? 'Salas'
      : _vm.isGov
      ? 'Projetos'
      : 'Municípios',"placeholder":"Selecione...","disabled":_vm.disabled,"clearable":_vm.clearable,"multiple":_vm.multiple,"item-value":"municipioId","item-text":"nome","rules":_vm.rules},on:{"change":(e) => {
      _vm.$emit('onChange', _vm.value);
      _vm.$emit(
        'nameChange',
        _vm.allValues
          .filter((val) => _vm.value.municipioId.includes(val.municipioId))
          .map((item) => item.nome)
      );
    }},scopedSlots:_vm._u([{key:"selection",fn:function({ item, index }){return [(index < _vm.maxDisplay && !_vm.mostrarMunicipios)?_c('v-chip',_vm._b({attrs:{"small":""}},'v-chip',item,false),[_c('span',[_vm._v(_vm._s(item.nome))])]):_vm._e(),(_vm.mostrarMunicipios)?_c('v-chip',_vm._b({attrs:{"small":""}},'v-chip',item,false),[_c('span',[_vm._v(_vm._s(item.nome))])]):_vm._e(),(index === _vm.maxDisplay && !_vm.mostrarMunicipios)?_c('span',{staticClass:"grey--text caption"},[_vm._v("(+"+_vm._s(_vm.value.municipioId.length - _vm.maxDisplay)+"\n      "+_vm._s(_vm.isParceiro
          ? "Parceiros"
          : _vm.isSala
          ? "Salas"
          : _vm.isGov
          ? "Projetos"
          : "Municípios")+")")]):_vm._e()]}}]),model:{value:(_vm.value.municipioId),callback:function ($$v) {_vm.$set(_vm.value, "municipioId", $$v)},expression:"value.municipioId"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum Município retornado ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }